import { useCallback } from "react";

import {
  notificationActions,
  selectNotification,
  selectNotificationSaveMessage,
} from "../../store/notifications/slice";

import { useAppDispatch, useAppSelector } from "../../store/root/hooks";
import {
  NotificationGetPayload,
  NotificationReadStatusOperators,
  NotificationReadStatusPayload,
  NotificationServiceOperators,
} from "../../types/notifications";

const useNotificationService = (): Readonly<NotificationServiceOperators> => {
  const dispatch = useAppDispatch();
  
  return {
    notificationList: useAppSelector(selectNotification),

    fetchAllNotifications: useCallback(
      (payload: NotificationGetPayload) => {
        dispatch(notificationActions.fetchAllisLoading());
        dispatch(notificationActions.fetchAll(payload));
      },
      [dispatch]
    ),
  
  };
};


const useAddReadStatusService = (): Readonly<NotificationReadStatusOperators> => {
  const dispatch = useAppDispatch();
  
  return {
    message : useAppSelector(selectNotificationSaveMessage),
    AddNotificationReadStatus: useCallback(
      (payload: NotificationReadStatusPayload) => {
        dispatch(notificationActions.AddReadStatusRequest(payload));
      },
      [dispatch]
    ),
  
  };
};

export { useNotificationService, useAddReadStatusService};
